import type { ApiModuleEndpoints } from '../types'

export const bookingApiEndpoints = {
  list: {
    method: 'GET',
    path: '/bookings',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/bookings/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/bookings',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/bookings/:id',
    requiresAuth: true,
  },
  cancel: {
    method: 'DELETE',
    path: '/bookings/:id',
    requiresAuth: true,
  },
  availability: {
    method: 'GET',
    path: '/bookings/availability',
    requiresAuth: true,
  },
  posSummary: {
    method: 'GET',
    path: '/bookings/pos-summary',
    requiresAuth: true,
  },
  extend: {
    method: 'POST',
    path: '/bookings/:id/extend',
    requiresAuth: true,
  },
  checkIn: {
    method: 'POST',
    path: '/bookings/:id/check-in',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
